module.exports = __webpack_public_path__ + "img/212.784a465f.png";